import Spinner from 'common/components/Spinner'
import {FC, useEffect, useState} from 'react'

// update modal title here
const title = 'Student Manager Help'

const Loading = () => {
  return (
    <div className='w-100 h-100 d-flex justify-content-center align-items-center flex-column'>
      <Spinner type='grow' size='lg' color='primary' />
    </div>
  )
}

const VideoFrame: FC<{src: string}> = ({src}) => {
  const [loading, setLoading] = useState(true)
  return (
    <>
      {loading && <Loading />}
      <iframe
        src={src}
        width='100%'
        height='480'
        allow='autoplay'
        title={title ?? 'help iframe'}
        onLoad={() => setLoading(false)}
        className={loading ? 'd-none' : 'd-block'}
      ></iframe>
    </>
  )
}

const Student: FC<{setTitle: (title: string) => void}> = ({setTitle}) => {
  useEffect(() => {
    if (title && setTitle) setTitle(title)
  }, [setTitle])

  return (
    <>
      {/* html starts here */}
      <h3>View Student Profile</h3>
      <VideoFrame src='https://drive.google.com/file/d/1aUVg7In7gbAvn8W3kbatK2W-zvV4khKD/preview' />

      <h3 className='mt-5'>Student List (PDF&Excel)</h3>
      <VideoFrame src='https://drive.google.com/file/d/1RyY4SZR8-cjvrOJEhNEMGjRg7yvX5roW/preview' />

      <h3 className='mt-5'>Edit or Update Student Info.</h3>
      <VideoFrame src='https://drive.google.com/file/d/1A-emonT83rCfkkZjkzioGK2XdMcTyIDT/preview' />

      <h3 className='mt-5'>Individual Student PDF (Print)</h3>
      <VideoFrame src='https://drive.google.com/file/d/1bw0CIWyr8PI2KbLXaUjXL21aJbPqd3sz/preview' />

      <h3 className='mt-5'>Student Leaving and Enrollment Certificate</h3>
      <VideoFrame src='https://drive.google.com/file/d/11zQKvXSwDlpmOJeu_bGJgPvAsuftAQ1P/preview' />

      <h3 className='mt-5'>Student Previous Classes History</h3>
      <VideoFrame src='https://drive.google.com/file/d/1ri8P6sJSS9FUYzGkV-mKvG7oVMWMDMl2/preview' />

      <h3 className='mt-5'>Delete student (In-activate)</h3>
      <VideoFrame src='https://drive.google.com/file/d/12RIsu762PaT1UK3UEU-qGB8lKHTqWFQj/preview' />

      <h3 className='mt-5'>Add Student</h3>
      <VideoFrame src='https://drive.google.com/file/d/1Rh4NUb-i-gJNgSM3A31ZP98giZq-0ius/preview' />

      {/* html ends here */}
    </>
  )
}

export default Student
